export const GET_BOOKING_TYPE = "GET_BOOKING_TYPE"
export const GET_BOOKING_TYPE_SUCCESS = "GET_BOOKING_TYPE_SUCCESS"
export const GET_BOOKING_TYPE_FAILED = "GET_BOOKING_TYPE_FAILED"

export const ADD_BOOKING = "ADD_BOOKING"
export const ADD_BOOKING_SUCCESS = "ADD_BOOKING_SUCCESS"
export const ADD_BOOKING_FAILED = "ADD_BOOKING_FAILED"

export const GET_BOOKING = "GET_BOOKING"
export const GET_BOOKING_SUCCESS = "GET_BOOKING_SUCCESS"
export const GET_BOOKING_FAILED = "GET_BOOKING_FAILED"
export const RESET_BOOKING = "RESET_BOOKING"
